import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { withDefaults } from '../proof';

// Live per-tenant config (filled with defaults).
export function subscribeConfig(tenantId, onChange, onError) {
  if (!tenantId) { onChange(withDefaults(null)); return () => {}; }
  return onSnapshot(
    doc(db, 'config', tenantId),
    (snap) => onChange(withDefaults(snap.exists() ? snap.data() : null)),
    (err) => (onError ? onError(err) : console.error('config listener error', err)),
  );
}
